import React, { useContext } from 'react';
import { Link } from "react-router-dom";
import LanguageContext from "../../helper/LanguageContext";
import { DE } from '../../Languages/DE';
import { EN } from '../../Languages/EN';

function CreateArticleChoose({ close, companyId, deptLocationId }) {
    const { isGerm, strings } = useContext(LanguageContext);

    return (
        <div className="create-article-modal-backdrop" onClick={close}>
            <div 
                className="create-article-modal" 
                onClick={(e) => e.stopPropagation()}
            >
                {/* Modal Header */}
                <div className="create-article-modal-header">
                    <h5 className="create-article-modal-title">
                        {strings.create_article}
                    </h5>
                    <button 
                        type="button"
                        className="kj-btn kj-btn--icon kj-btn--neutral"
                        onClick={close}
                    >
                        <span className="material-symbols-outlined">close</span>
                    </button>
                </div>

                {/* Modal Body */}
                <div className="create-article-modal-body">
                    {/* External Article Option */}
                    <Link 
                        className="create-article-option create-article-option-external"
                        to={{
                            pathname: `/add-company-article/${companyId}`,
                            state: { from: "external", articleType: 0, deptLocationId, companyId }
                        }}
                        onClick={close}
                    >
                        <span className="material-symbols-outlined create-article-option-icon">public</span>
                        <div className="create-article-option-text">
                            <span className="create-article-option-title">
                                {strings.new_article_selection}
                            </span>
                            <span className="create-article-option-subtitle">
                                {strings.visible_to_all_followers}
                            </span>
                        </div>
                        <span className="material-symbols-outlined create-article-option-arrow">chevron_right</span>
                    </Link>

                    {/* Internal Article Option */}
                    <Link 
                        className="create-article-option create-article-option-internal"
                        to={{
                            pathname: `/add-company-article/${companyId}`,
                            state: { from: "internal", articleType: 1, companyId: companyId, deptLocationId }
                        }}
                        onClick={close}
                    >
                        <span className="material-symbols-outlined create-article-option-icon">lock</span>
                        <div className="create-article-option-text">
                            <span className="create-article-option-title">
                                {strings.new_article_selection_internal}
                            </span>
                            <span className="create-article-option-subtitle">
                                {strings.only_visible_to_employees}
                            </span>
                        </div>
                        <span className="material-symbols-outlined create-article-option-arrow">chevron_right</span>
                    </Link>
                </div>
            </div>
        </div>
    );
}

export default CreateArticleChoose;
